module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-light-58a8a4b38001d.f9d069a.woff2";